import { LEGAL_DOCS } from "@pandas/http-client";
import { createFileRoute, notFound } from "@tanstack/react-router";
import Legal from "@/features/onboarding/pages/legal/Legal";

const LEGAL_TYPES = new Set<string>(LEGAL_DOCS);

export const Route = createFileRoute("/$locale/$partner/$pageType")({
	beforeLoad: ({ params }) => {
		if (!LEGAL_TYPES.has(params.pageType)) {
			throw notFound();
		}
	},
	component: Legal,
});
